/**
 * ClickHouse daemon management for local development
 *
 * This module provides utilities to download, install, and manage
 * a local ClickHouse daemon process. Ideal for development environments
 * where you want a standalone ClickHouse server.
 *
 * @example
 * ```typescript
 * import { connect } from '@dotdo/db-clickhouse/daemon'
 *
 * // Auto-downloads binary and starts daemon if needed
 * const client = await connect({
 *   database: 'mydb',
 *   installDir: '~/.clickhouse'
 * })
 * ```
 */
export * from './daemon/index.js'
